import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Dictionary } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import moment from 'moment-mini'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { combineLatest, Observable, Subscription } from 'rxjs'
import { map, take } from 'rxjs/operators'
import { AppState } from '../../../../core/core.state'
import { settingSelectors } from '../../../../core/settings/settings.selectors'
import { Product } from '../../../product/product'
import { productSelectors } from '../../../product/product.selectors'
import { SerieProposal } from '../serie-proposal'
import { SerieProposalShowModalComponent } from '../show-modal/show.component'

@UntilDestroy()
@Component({
  selector: 'serie-proposal-overview-schedule',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class SerieProposalOverviewScheduleComponent implements OnInit {
  @Input() selectedBookableProductIds$: Observable<number[]>
  @Input() dependantProductIds$: Observable<number[]>
  @Input() serieProposals: SerieProposal[]
  @Output() onFetchSerieProposals = new EventEmitter<any>()
  @Input() dependantProductsMap: { [key: number]: number[] } = {}
  public selectedLanguage$: Observable<string>
  public selectedFilters$: Observable<any>
  public defaultStartDay = moment().startOf('year')
  public allProducts$: Observable<Product[]>
  public productEntities$: Observable<Dictionary<Product>>
  public bookableProducts$: Observable<Product[]>
  public targetedProductsIds$: Observable<any>

  public selectedDay = moment().startOf('day')

  public bsModalRef: BsModalRef
  private subscriptions: Subscription[] = []
  constructor(
    private store: Store<AppState>,
    private modalService: BsModalService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )

    this.targetedProductsIds$ = combineLatest([
      this.selectedBookableProductIds$,
      this.dependantProductIds$
    ]).pipe(
      untilDestroyed(this),
      map(([selectedBookableProductIds, dependantProductIds]) => {
        return [
          ...(selectedBookableProductIds ?? []),
          ...(dependantProductIds ?? [])
        ]
      })
    )

    this.allProducts$ = this.store.select(productSelectors.selectAll)

    this.productEntities$ = this.store.select(productSelectors.selectEntities)
  }

  public onClickEvent(serieProposal: SerieProposal) {
    this.bsModalRef = this.modalService.show(SerieProposalShowModalComponent, {
      initialState: {
        serieProposalId: serieProposal.id
      },
      class: 'modal-xl modal-dialog-scrollable'
    })

    this.bsModalRef.onHide.pipe(take(1)).subscribe((modal) => {
      this.onFetchSerieProposals.emit()
    })
  }

  public onDaySelected(day: moment.Moment) {
    this.onFetchSerieProposals.emit()
    this.selectedDay = day.clone()
  }

  ngOnDestroy() {
    this.subscriptions.map((s) => s.unsubscribe())
  }
}
